import axios from 'axios';
import QueryString from 'qs';
import { z } from 'zod';

import { mediaDataSchema } from './blogs';
import { apiRoutes, StripeCollectionDataZodSchema } from './config';

export const teamMembersSchema = z.object({
  photo: mediaDataSchema.nullable(),
  name: z.string(),
  description: z.string(),
  role: z.string(),
  section: z.enum([
    'Management Board',
    'Operations & People',
    'Marketing',
    'Engineering & Design',
  ]),
  linkedin: z.string().nullable(),
  updatedAt: z.string(),
});
export type TeamMembers = z.infer<typeof teamMembersSchema>;
export const getTeamMembers = async () => {
  const { data } = await (async () => {
    return axios.get(apiRoutes.teamMembers._root, {
      params: {
        populate: ['photo'],
        sort: ['linkedin:desc', 'updatedAt:desc'],
      },
      paramsSerializer: {
        serialize: (params) =>
          QueryString.stringify(params, { encodeValuesOnly: true }),
      },
    });
  })();

  const teamMembers =
    StripeCollectionDataZodSchema(teamMembersSchema).parse(data);

  teamMembers.data.sort((a, b) => {
    if (a.linkedin && !b.linkedin) return -1;
    if (!a.linkedin && b.linkedin) return 1;

    return new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime();
  });

  return teamMembers;
};
